const config = {
    title: 'ClinicIQ',
    defaultLang: 'ru',
    langs: ['ru', 'en'],
    loginAuthClient: 'devglan-client',
    loginAuthSecret: 'devglan-secret',
    workDayStart: '08:00:00',
    workDayEnd: '22:00:00',
    childAge: 14,
    pages: ["appointment", "schedule", "clients", "employees", "tasks", "contacts", "price", "report", "expenses", "permissions", "egisz", "settings"],
    pagesShort: ["appointment", "schedule", "tasks", "employees", "price", "report"],
    sexes: [{ id: null, name: "client.notIndicated" }, { id: 0, name: "sex.male" }, { id: 1, name: "sex.female" }],
    roles: {
        1: 'Директор',
        2: 'Зам. директора',
        3: 'Глав. врач',
        4: 'Доктор',
        5: 'Главный ассистент',
        6: 'Ассистент',
        7: 'Администратор',
        8: 'Гигиенист',
        9: 'Кассир',
        10: 'Помощник',
        12: 'Координатор',
        13: 'Сотрудник',
        100: 'Роль не указана'
    },
    allowedRoles: {
        clientDeleteButton: [1, 2],
        pages: {
            appointment: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 12, 13, 100],
            schedule: [1, 2, 3, 7, 9, 12],
            clients: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 12, 13],
            employees: [1, 2, 3, 7, 9, 12],
            contacts: [],
            price: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 12, 13],
            report: [1, 2, 3, 4, 7, 8, 9, 12], /* [1, 2, 3, 7, 9, 12]*/
            expenses: [1, 2],
            permissions: [],
            egisz: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 12, 13, 100],
            settings: [1, 2],
            tasks: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 12, 13, 100],
        },
        reportSalary: [1, 2, 3, 4, 8],
        reportDay: [1, 2, 3, 7, 9, 12],
        reportLoad: [1, 2, 3, 4, 8],
    },
    rolesList: [
        { id: 1, name: "roles.director" },
        { id: 2, name: "roles.dep_director" },
        { id: 3, name: "roles.main_doctor" },
        { id: 4, name: "roles.doctor" },
        { id: 5, name: "roles.main_assistant" },
        { id: 6, name: "roles.assistant" },
        { id: 7, name: "roles.administrator" },
        { id: 8, name: "roles.hygienist" },
        { id: 9, name: "roles.cashier" },
        { id: 10, name: "roles.helpeer" },
        { id: 12, name: "roles.coordinator" },
        { id: 13, name: "roles.employee" },
        { id: 100, name: "roles.nd_role" }
    ],
    employeeStatuses: [
        { id: "WORK", name: "employee.status_work" },
        { id: "ON_VACATION", name: "employee.status_hired" },
        { id: "FIRED", name: "employee.status_fired" }
    ],
    clientStatuses: [
        { id: "NOVICE", name: "clientStatuses.NOVICE" },
        { id: "PERMANENT", name: "clientStatuses.PERMANENT" },
        { id: "REFUSED_TREATMENT", name: "clientStatuses.REFUSED_TREATMENT" },
        { id: "NOT_AVAILABLE_PERMANENTLY", name: "clientStatuses.NOT_AVAILABLE_PERMANENTLY" },
        { id: "BLACK_LIST", name: "clientStatuses.BLACK_LIST" },
        { id: "DELETED", name: "clientStatuses.DELETED" },
        { id: "NOT_DISTURB", name: "clientStatuses.NOT_DISTURB" },
        { id: "UNKNOWN", name: "clientStatuses.UNKNOWN" },
        /*{ id: "CREATED", name: "clientStatuses.NOVICE" },
        { id: "PRIMARY", name: "clientStatuses.NOVICE" },
        { id: "REGULAR", name: "clientStatuses.PERMANENT" },*/
        { id: "PASSED_AWAY", name: "clientStatuses.DIED" },
    ],
    statusTreatment: [
        { id: "sanitized", name: "clientStatuses.sanitized" },
        { id: "refused", name: "clientStatuses.refused" },
        { id: "continuation", name: "clientStatuses.continuation" },
        { id: "suspended", name: "clientStatuses.suspended" },
    ],
    relations: [
        { id: "FATHER_SON", name: "clientRealtions.SON", sex: "MALE", sexFrom: "MALE", relationId: "SON_FATHER" },
        { id: "SON_FATHER", name: "clientRealtions.FATHER", sex: "MALE", sexFrom: "MALE", relationId: "FATHER_SON" },
        { id: "FATHER_DAUGHTER", name: "clientRealtions.DAUGHTER", sex: "FEMALE", sexFrom: "MALE", relationId: "DAUGHTER_FATHER" },
        { id: "DAUGHTER_FATHER", name: "clientRealtions.FATHER", sex: "MALE", sexFrom: "FEMALE", relationId: "FATHER_DAUGHTER" },
        { id: "MOTHER_SON", name: "clientRealtions.SON", sex: "MALE", sexFrom: "FEMALE", relationId: "SON_MOTHER" },
        { id: "SON_MOTHER", name: "clientRealtions.MOTHER", sex: "FEMALE", sexFrom: "MALE", relationId: "MOTHER_SON" },
        { id: "MOTHER_DAUGHTER", name: "clientRealtions.DAUGHTER", sex: "FEMALE", sexFrom: "FEMALE", relationId: "DAUGHTER_MOTHER" },
        { id: "DAUGHTER_MOTHER", name: "clientRealtions.MOTHER", sex: "FEMALE", sexFrom: "FEMALE", relationId: "MOTHER_DAUGHTER" },
        { id: "HUSBAND_WIFE", name: "clientRealtions.WIFE", sex: "FEMALE", sexFrom: "MALE", relationId: "WIFE_HUSBAND" },
        { id: "WIFE_HUSBAND", name: "clientRealtions.HUSBAND", sex: "MALE", sexFrom: "FEMALE", relationId: "HUSBAND_WIFE" },
        { id: "GRANDFATHER_GRANDSON", name: "clientRealtions.GRANDSON", sex: "MALE", sexFrom: "MALE", relationId: "GRANDSON_GRANDFATHER" },
        { id: "GRANDSON_GRANDFATHER", name: "clientRealtions.GRANDFATHER", sex: "MALE", sexFrom: "MALE", relationId: "GRANDFATHER_GRANDSON" },
        { id: "GRANDFATHER_GRANDDAUGHTER", name: "clientRealtions.GRANDDAUGHTER", sex: "FEMALE", sexFrom: "MALE", relationId: "GRANDDAUGHTER_GRANDFATHER" },
        { id: "GRANDDAUGHTER_GRANDFATHER", name: "clientRealtions.GRANDFATHER", sex: "MALE", sexFrom: "FEMALE", relationId: "GRANDFATHER_GRANDDAUGHTER" },
        { id: "GRANDMOTHER_GRANDSON", name: "clientRealtions.GRANDSON", sex: "MALE", sexFrom: "FEMALE", relationId: "GRANDMOTHER_GRANDSON" },
        { id: "GRANDSON_GRANDMOTHER", name: "clientRealtions.GRANDMOTHER", sex: "FEMALE", sexFrom: "MALE", relationId: "GRANDSON_GRANDMOTHER" },
        { id: "GRANDMOTHER_GRANDDAUGHTER", name: "clientRealtions.GRANDDAUGHTER", sex: "FEMALE", sexFrom: "FEMALE", relationId: "GRANDDAUGHTER_GRANDMOTHER" },
        { id: "GRANDDAUGHTER_GRANDMOTHER", name: "clientRealtions.GRANDMOTHER", sex: "FEMALE", sexFrom: "FEMALE", relationId: "GRANDMOTHER_GRANDDAUGHTER" },
        { id: "BROTHER_SISTER", name: "clientRealtions.SISTER", sex: "FEMALE", sexFrom: "MALE", relationId: "SISTER_BROTHER" },
        { id: "SISTER_BROTHER", name: "clientRealtions.BROTHER", sex: "MALE", sexFrom: "FEMALE", relationId: "BROTHER_SISTER" },
        { id: "BROTHER_BROTHER", name: "clientRealtions.BROTHER", sex: "MALE", sexFrom: "MALE", relationId: "BROTHER_BROTHER" },
        { id: "SISTER_SISTER", name: "clientRealtions.SISTER", sex: "FEMALE", sexFrom: "FEMALE", relationId: "SISTER_SISTER" },
        { id: "NOT_DEFINED", name: "clientRealtions.NOT_DEFINED", sex: "ALL" },
    ],
    /*invite: {
        1: { id: 1, name: "invHygiene" }, 
        2: { id: 2, name: "invRG" }, 
        3: { id: 3, name: "invInspection" },
        4: { id: 4, name: "invImplantation" }, 
        5: { id: 5, name: "invOperation" },
        6: { id: 6, name: "invShapers" },
        7: { id: 7, name: "invProsthetics" },
        8: { id: 8, name: "invAppointment" },
        9: { id: 9, name: "invKT" },
        10: { id: 10, name: "invTreatment" },
        11: { id: 15, name: "invMedicalExamination" },
    },*/
    invite: {
        1: { id: 1, name: "invHygiene" },
        2: { id: 2, name: "invRG" },
        3: { id: 3, name: "invInspection" },
        4: { id: 6, name: "invImplantation" },
        5: { id: 7, name: "invOperation" },
        6: { id: 8, name: "invShapers" },
        7: { id: 5, name: "invProsthetics" },
        8: { id: 10, name: "invAppointment" },
        9: { id: 11, name: "invKT" },
        10: { id: 12, name: "invTreatment" },
        11: { id: 15, name: "invMedicalExamination" }
    },
    invitePeriod: [
        {
            id: 1,
            name: "invitePeriod.inv3day",
            baseName: "3_day",
            attr: [],
            add: { type: "day", amount: 3 }
        },
        {
            id: 2,
            name: "invitePeriod.inv1week",
            baseName: "1_week",
            attr: ["invHygiene", "invInspection", "invAppointment"],
            add: { type: "day", amount: 7 }
        },
        {
            id: 3,
            name: "invitePeriod.inv2week",
            baseName: "2_week",
            attr: ["invRG", "invOperation"],
            add: { type: "day", amount: 14 }
        },
        {
            id: 4,
            name: "invitePeriod.inv1month",
            baseName: "1_month",
            attr: ["invHygiene", "invRG", "invImplantation", "invOperation", "invKT", "invTreatment"],
            add: { type: "month", amount: 1 }
        },
        {
            id: 5,
            name: "invitePeriod.inv2month",
            baseName: "2_month",
            attr: ["invHygiene", "invRG", "invImplantation", "invOperation", "invKT", "invTreatment", "invMedicalExamination"],
            add: { type: "month", amount: 2 }
        },
        {
            id: 6,
            name: "invitePeriod.inv3month",
            baseName: "3_month",
            attr: ["invHygiene", "invInspection", "invImplantation", "invAppointment", "invKT", "invTreatment", "invMedicalExamination"],
            add: { type: "month", amount: 3 }
        },
        {
            id: 7,
            name: "invitePeriod.inv4month",
            baseName: "4_month",
            attr: ["invHygiene", "invRG", "invInspection", "invOperation", "invShapers", "invKT", "invTreatment", "invProsthetics", "invMedicalExamination"],
            add: { type: "month", amount: 4 }
        },
        {
            id: 8,
            name: "invitePeriod.inv5month",
            baseName: "5_month",
            attr: ["invInspection", "invImplantation", "invKT", "invTreatment", "invMedicalExamination"],
            add: { type: "month", amount: 5 }
        },
        {
            id: 9,
            name: "invitePeriod.inv6month",
            baseName: "6_month",
            attr: ["invHygiene", "invRG", "invInspection", "invOperation", "invShapers", "invAppointment", "invKT", "invTreatment", "invProsthetics", "invMedicalExamination"],
            add: { type: "month", amount: 6 }
        },
        {
            id: 10,
            name: "invitePeriod.inv1year",
            baseName: "12_month",
            attr: ["invRG", "invInspection", "invOperation", "invKT", "invTreatment", "invMedicalExamination"],
            add: { type: "month", amount: 12 }
        },
        {
            id: 11,
            baseName: "3_everymonth",
            name: "invitePeriod.invEvery3months",
            attr: []
        },
        {
            id: 12,
            baseName: "6_everymonth",
            name: "invitePeriod.invEvery6months",
            attr: []
        },
    ],
    replaceReasons: [
        { id: 1, name: "replaceReasons.absence" },
        { id: 9, name: "replaceReasons.other" },
        { id: 10, name: "replaceReasons.callBackMyself" },
        { id: 11, name: "replaceReasons.fellIll" },
        { id: 12, name: "replaceReasons.canNotGetInTime" },
        { id: 13, name: "replaceReasons.changedPlans" },
        { id: 14, name: "replaceReasons.financialProblem" },
        { id: 16, name: "replaceReasons.moveToAnotherDay" },
    ],
    diagnosis: [
        { id: 1, flexId: 1, title: "diagnosis.dgCaries", abb: "С", children: true },
        { id: 2, flexId: 2, title: "diagnosis.dgSeal", abb: "П", children: true },
        { id: 3, flexId: 3, title: "diagnosis.dgFilling", abb: "П/C", children: true },
        { id: 4, flexId: 4, title: "diagnosis.dgPulpitis", abb: "Pl", children: true },
        { id: 5, flexId: 5, title: "diagnosis.dgPeriodont", abb: "Pt", children: true },
        { id: 6, flexId: 6, title: "diagnosis.dgRoot", abb: "R", children: true },
        { id: 7, flexId: 7, title: "diagnosis.dgMissing", abb: "О", children: true },
        { id: 22, flexId: 8, title: "diagnosis.dgSkol", abb: "ск", children: true },
        { id: 8, flexId: 9, title: "diagnosis.dgDentalD", abb: "з/о", children: true },
        { id: 9, flexId: 10, title: "diagnosis.dgSealDef", abb: "д/п", children: true },
        { id: 10, flexId: 11, title: "diagnosis.dgCrown", abb: "К", children: true },
        { id: 11, flexId: 12, title: "diagnosis.dgTab", abb: "вк", children: true },
        { id: 12, flexId: 13, title: "diagnosis.dgShaper", abb: "Ф", children: false },
        { id: 13, flexId: 14, title: "diagnosis.dgImplant", abb: "И", children: false },
        { id: 14, flexId: 15, title: "diagnosis.dgRecession", abb: "Р", children: true },
        { id: 15, flexId: 16, title: "diagnosis.dgWedge", abb: "кл/д", children: true },
        { id: 16, flexId: 17, title: "diagnosis.dgDeep", abb: "г/ф", children: true },
        { id: 17, flexId: 18, title: "diagnosis.dgSealant", abb: "г/р", children: true },
        { id: 18, flexId: 19, title: "diagnosis.dgMobility1", abb: "I", children: true },
        { id: 19, flexId: 20, title: "diagnosis.dgMobility2", abb: "II-III", children: true },
        { id: 20, flexId: 21, title: "diagnosis.dgCervical", abb: "С/пр", children: true },
        { id: 21, flexId: 22, title: "diagnosis.dgSecondary", abb: "С/втч", children: true },
        { id: 23, flexId: 23, title: "diagnosis.dgRetinated", abb: "ret", children: false },
        { id: 24, flexId: 24, title: "diagnosis.dgDystopian", abb: "dys", children: false },
        { id: 25, flexId: 25, title: "diagnosis.dgAesthetic", abb: "э/д", children: false },
        { id: 26, flexId: 26, title: "diagnosis.dgCeramicInlay", abb: "In", children: true },
        { id: 27, flexId: 27, title: "diagnosis.dislocationTooth", abb: "Lux", children: true },
        { id: 28, flexId: 28, title: "diagnosis.crack", abb: "Fr", children: true },
        { id: 29, flexId: 29, title: "diagnosis.temporaryCrown", abb: "Вр/К", children: false },
    ],
    treatmentDirection: [
        { id: 1, name: "treatmentDirection.therapy" },
        { id: 2, name: "treatmentDirection.surgery" },
        { id: 3, name: "treatmentDirection.orthopedics" },
        { id: 4, name: "treatmentDirection.orthodontics" },
        { id: 5, name: "treatmentDirection.hygiene" },
        { id: 6, name: "treatmentDirection.whitening" },
        { id: 7, name: "treatmentDirection.periodontics" },
        { id: 8, name: "treatmentDirection.children" },
        { id: 9, name: "treatmentDirection.implantation" },
    ],
    treatmentWorkStatus: [
        { id: 1, name: "treatmentWorkStatus.takeNote" },
        { id: 2, name: "treatmentWorkStatus.dontDelay" },
        { id: 3, name: "treatmentWorkStatus.сontinue" },
        { id: 4, name: "treatmentWorkStatus.anotherClinic" },
        { id: 5, name: "treatmentWorkStatus.tempFilling" },
        { id: 6, name: "treatmentWorkStatus.xrayControl" },
        { id: 8, name: "treatmentWorkStatus.watch" },
        { id: 7, name: "treatmentWorkStatus.cured" },
    ],
    treatmentType: [
        { id: "RECOMMENDER", name: "client.recommended" },
        { id: "ALTERNATIVE", name: "client.alternative" },
    ],
    transactionType: [
        { id: "CARD", name: "transactionType.card", key: "card" },
        { id: "CASH", name: "transactionType.cash", key: "cash" },
        { id: "BONUS", name: "transactionType.bonus", key: "bonus" },
        { id: "NON_CASH", name: "transactionType.nonCash", key: "nonCash" },
        { id: "SETTLEMENT_ACCOUNT", name: "transactionType.settlementAccount", key: "settlementAccount" },
        { id: "BONUS_EMPLOYEE", name: "transactionType.bonusEmployee", key: "bonusEmployee" },
        { id: "ARTEMENKO", name: "transactionType.artemenko", key: "artemenko" },
    ],
    directionType: [
        { id: "DIRECTION_SUBSTRACT", name: "directionType.substract" },
        { id: "DIRECTION_GET", name: "directionType.get" },
        { id: "DIRECTION_ADD", name: "directionType.add" },
        { id: "DIRECTION_CANCEL", name: "directionType.cancel" },
        { id: "DIRECTION_CREDIT", name: "directionType.credit" },
        { id: "DIRECTION_DEBT", name: "directionType.debt" },
    ],
    occlusion: [
        { uid: 0, id: "OCCLUSION_NOT_DEFINED", name: "occlusion.notDefined" },
        { uid: 1, id: "OCCLUSION_DISTAL", name: "occlusion.distal" },
        { uid: 2, id: "OCCLUSION_MEZIAL", name: "occlusion.mezial" },
        { uid: 3, id: "OCCLUSION_DEEP", name: "occlusion.deep" },
        { uid: 4, id: "OCCLUSION_OPEN", name: "occlusion.open" },
        { uid: 5, id: "OCCLUSION_CROSS", name: "occlusion.cross" },
        { uid: 6, id: "OCCLUSION_ORTOGNAST", name: "occlusion.ortognast" },
        { uid: 7, id: "OCCLUSION_PROGEN", name: "occlusion.progen" },
        { uid: 8, id: "OCCLUSION_BEPROGNAT", name: "occlusion.beprognat" },
        { uid: 9, id: "OCCLUSION_DIRECT", name: "occlusion.direct" },
        { uid: 10, id: "OCCLUSION_NOT_DETERMINED", name: "occlusion.notDetermined" },
    ],
    documents: [
        { "id": "TEMPLATE_AGREEMENT", "name": "Клиентское соглашение" },
        { "id": "TEMPLATE_2", "name": "Договор для пациента" },
        { "id": "TEMPLATE_3", "name": "Согласие на зубную имплантацию" },
        { "id": "TEMPLATE_4", "name": "Согласие на лечение кариеса" },
        { "id": "TEMPLATE_5", "name": "Согласие на ортодонт.лечение" },
        { "id": "TEMPLATE_6", "name": "Согласие на ортопед. лечение" },
        { "id": "TEMPLATE_7", "name": "Согласие на отбеливание" },
        { "id": "TEMPLATE_8", "name": "Согласие на парадонт.лечение" },
        { "id": "TEMPLATE_9", "name": "Согласие на проф. гигиену" },
        { "id": "TEMPLATE_10", "name": "Согласие на хирург лечение" },
        { "id": "TEMPLATE_11", "name": "Согласие на эндодонт. лечение" },
        { "id": "belayraduga_CUSTOM_12", "name": "Договор" },
        { "id": "belayraduga_CUSTOM_13", "name": "Договор" },
        { "id": "belayraduga_CUSTOM_14", "name": "Договор с представителем" },
        { "id": "belayraduga_CUSTOM_15", "name": "Положение о гарантиях" },
        { "id": "belayraduga_CUSTOM_16", "name": "Положение о гарантиях" },
        { "id": "belayraduga_CUSTOM_17", "name": "ДИС Ортодонтия" },
        { "id": "belayraduga_CUSTOM_18", "name": "ДИС ортопедия" },
        { "id": "belayraduga_CUSTOM_19", "name": "ДИС ортопедия восстановительное лечение" },
        { "id": "belayraduga_CUSTOM_20", "name": "ДИС ортопедия коронки и мосты" },
        { "id": "belayraduga_CUSTOM_21", "name": "ДИС ортопедия съемные протезы" },
        { "id": "belayraduga_CUSTOM_22", "name": "ДИС имплантация" },
        { "id": "belayraduga_CUSTOM_23", "name": "ДИС синус-лифтинг" },
        { "id": "belayraduga_CUSTOM_24", "name": "ДИС костная пластика" },
        { "id": "belayraduga_CUSTOM_25", "name": "ДИС удаление зуба" },
        { "id": "belayraduga_CUSTOM_26", "name": "ДИС разрез" },
        { "id": "belayraduga_CUSTOM_27", "name": "ДИС зубосохраняющие операции" },
        { "id": "belayraduga_CUSTOM_28", "name": "ДИС кариес" },
        { "id": "devtest_CUSTOM_46", "name": "ИДС пульпит" },
        { "id": "belayraduga_CUSTOM_30", "name": "ДИС периодонтит" },
        { "id": "belayraduga_CUSTOM_31", "name": "ДИС перелечивание каналов" },
        { "id": "belayraduga_CUSTOM_32", "name": "ДИС реставрация депульпированного зуба" },
        { "id": "belayraduga_CUSTOM_33", "name": "ДИС гигиена" },
        { "id": "belayraduga_CUSTOM_34", "name": "ДИС отбеливание" },
        { "id": "belayraduga_CUSTOM_35", "name": "ИДС имплантация" },
        { "id": "belayraduga_CUSTOM_36", "name": "ИДС ортодонтия" },
        { "id": "belayraduga_CUSTOM_37", "name": "ИДС ортопедия" },
        { "id": "belayraduga_CUSTOM_38", "name": "ИДС отбеливание" },
        { "id": "belayraduga_CUSTOM_39", "name": "ИДС пародонтология" },
        { "id": "belayraduga_CUSTOM_40", "name": "ИДС рентген" },
        { "id": "belayraduga_CUSTOM_41", "name": "ИДС терапия" },
        { "id": "belayraduga_CUSTOM_42", "name": "ИДС хирургия" },
        { "id": "belayraduga_CUSTOM_43", "name": "ИДС эндодонтия" },
        { "id": "belayraduga_CUSTOM_44", "name": "Договор с представителем" },
        { "id": "belayraduga_CUSTOM_45", "name": "Договор не правильный!" },
        { "id": "belayraduga_CUSTOM_46", "name": "ОСНОВНОЙ ДОГОВОР" },
        { "id": "belayraduga_CUSTOM_47", "name": "Договор с представителем 1" },
        { "id": "belayraduga_CUSTOM_48", "name": "Договор с представителем 1" },
        { "id": "belayraduga_CUSTOM_49", "name": "Договор с представителем 1" },
        { "id": "belayraduga_CUSTOM_50", "name": "ОСНОВНОЙ ДОГОВОР С ПРЕДСТ." },
        { "id": "belayraduga_CUSTOM_51", "name": "ДОГОВОР ИП АРТЕМЕНКО" },
        { "id": "belayraduga_CUSTOM_52", "name": "ИДС КОРОНА" },
        { "id": "TEMPLATE_12", "name": "Скан паспорта" },
        { "id": "belayraduga_CUSTOM_54", "name": "ИДС ICON Дети" },
        { "id": "belayraduga_CUSTOM_55", "name": "ИДС микроабразия" },
        { "id": "belayraduga_CUSTOM_56", "name": "тест 12-08-2020" },
        { "id": "belayraduga_CUSTOM_57", "name": "ИДС ОСМОТР" },
        { "id": "belayraduga_CUSTOM_58", "name": "ИДС анестезия ДЕТИ" },
        { "id": "belayraduga_CUSTOM_59", "name": "ИДС коронка ДЕТИ" },
        { "id": "belayraduga_CUSTOM_60", "name": "ИДС пульпит ДЕТИ" },
        { "id": "belayraduga_CUSTOM_61", "name": "ИДС рентген ДЕТИ" },
        { "id": "belayraduga_CUSTOM_62", "name": "ИДС терапия ДЕТИ" },
        { "id": "belayraduga_CUSTOM_63", "name": "ИДС эндо ДЕТИ" },
        { "id": "belayraduga_CUSTOM_64", "name": "ИДС удаление зуба ДЕТИ" },
        { "id": "belayraduga_CUSTOM_65", "name": "ИДС ортодонтия ДЕТИ" },
        { "id": "belayraduga_CUSTOM_66", "name": "ИДС гигиена ДЕТИ" },
        { "id": "belayraduga_CUSTOM_67", "name": "Направление на рентген" },
        { "id": "belayraduga_CUSTOM_68", "name": "Протокол на рентген" },
        { "id": "belayraduga_CUSTOM_89", "name": "ИДС хирургия ДЕТИ" },
        { "id": "belayraduga_CUSTOM_69", "name": "ИДС гигиена взрослые" },
        { "id": "belayraduga_CUSTOM_74", "name": "ИДС местная анестезия ДЕТИ" },
        { "id": "belayraduga_CUSTOM_70", "name": "Клиентское соглашение" },
        { "id": "belayraduga_CUSTOM_75", "name": "ИДС осмотр ДЕТИ" },
        { "id": "belayraduga_CUSTOM_76", "name": "ИДС ICON взрослые" },
        { "id": "belayraduga_CUSTOM_77", "name": "Пакетное соглашение Зиларт= Таганка 2023" },
        { "id": "belayraduga_CUSTOM_78", "name": "Пакетное соглашение БР1" },
        { "id": "belayraduga_CUSTOM_79", "name": "ОСНОВНОЙ ДОГОВОР ДМС" },
        { "id": "belayraduga_CUSTOM_80", "name": "ОСНОВНОЙ ДОГОВОР ЮР.ЛИЦА" },
        { "id": "belayraduga_CUSTOM_81", "name": "ИДС седация Пропофол дети" },
        { "id": "belayraduga_CUSTOM_82", "name": "ИДС наркоз ДЕТИ СЕВОРАН" },
        { "id": "belayraduga_CUSTOM_83", "name": "ИДС седация Пропофол взрослые" },
        { "id": "belayraduga_CUSTOM_84", "name": "СЕРТ НА ГИГИЕНУ" },
        { "id": "belayraduga_CUSTOM_85", "name": "ИДС анестезия ВЗРОСЛЫЕ" },
        { "id": "belayraduga_CUSTOM_86", "name": "ИДС закись азота дети" },
        { "id": "belayraduga_CUSTOM_87", "name": "ИДС закись азота взрослые" },
        { "id": "belayraduga_CUSTOM_88", "name": "ИДС Альфа Страхование" },
        { "id": "belayraduga_CUSTOM_90", "name": "Пакетное соглашение брекет Зиларт= Таганка 2023" },
        { "id": "belayraduga_CUSTOM_91", "name": "Пакетное соглашение брекет БР1" },
        { "id": "belayraduga_CUSTOM_92", "name": "СЕРТ НА КАРИЕС" }
    ],
    dayOfWeek: ["MONDAY", "TUESDAY", "WEDNESDAY", "THURSDAY", "FRIDAY", "SATURDAY", "SUNDAY"],

    specsStomatList: [
        { id: 1, title: "specs.id1" },
        { id: 2, title: "specs.id2" },
        { id: 3, title: "specs.id3" },
        { id: 4, title: "specs.id4" },
        { id: 5, title: "specs.id5" },
        { id: 6, title: "specs.id6" },
        { id: 7, title: "specs.id7" },
        { id: 8, title: "specs.id8" },
        { id: 9, title: "specs.id9" },
        { id: 10, title: "specs.id10" },
        { id: 11, title: "specs.id11" }
    ],

    specsMedGeneralList: [
        { id: 12, title: "specs.id12" },
        { id: 13, title: "specs.id13" },
        { id: 14, title: "specs.id14" },
        { id: 15, title: "specs.id15" },
        { id: 16, title: "specs.id16" },
        { id: 17, title: "specs.id17" },
        { id: 18, title: "specs.id18" },
        { id: 19, title: "specs.id19" },
        { id: 20, title: "specs.id20" },
        { id: 21, title: "specs.id21" },
        { id: 22, title: "specs.id22" },
        { id: 23, title: "specs.id23" },
        { id: 24, title: "specs.id24" },
        { id: 25, title: "specs.id25" },
        { id: 26, title: "specs.id26" },
        { id: 27, title: "specs.id27" },
        { id: 28, title: "specs.id28" },
        { id: 29, title: "specs.id29" },
        { id: 30, title: "specs.id30" },
        { id: 31, title: "specs.id31" },
        { id: 32, title: "specs.id32" }
    ],

    statusItems: [
        { id: "DOCTOR_APPROVE", name: "egiszStatuses.signed", color: "#FCE4F2" },
        { id: "UNFILLED", name: "egiszStatuses.unfilled", color: "#FFEBEC" },
        { id: "FAILED", name: "egiszStatuses.notAccepted", color: "#FFEBEC" },
        { id: "PENDING", name: "egiszStatuses.inProgress", color: "#FFE7D0" },
        { id: "DOCTOR_CLINIC_APPROVE", name: "egiszStatuses.approve", color: "#FFE7D0" },
        { id: "OPTIMIZING", name: "egiszStatuses.underReview", color: "#FBF2D5" },
        /*{ id: "OPTIMIZING_PENDING", name: "egiszStatuses.optimizing", color: "#FBF2D5" },*/
        /*{ id: "FILLED", name: "egiszStatuses.filled", color: "#F1F5D8" },*/
        { id: "COMPLETED", name: "egiszStatuses.accepted", color: "#D1EBE9" },
        { id: "INVOICE_DIARY_FILLED", name: "egiszStatuses.filled", color: "#F1F5D8" },
        { id: "INVOICE_FILLED", name: "egiszStatuses.invoiceFilled", color: "#FBF2D5" },
        { id: "DIARY_FILLED", name: "egiszStatuses.diaryFilled", color: "#FBF2D5" },
        { id: "INSPECTION_FILLED", name: "egiszStatuses.inspectionFilled", color: "#FBF2D5" },
        { id: "NO_INVOICE", name: "egiszStatuses.noInvoice", color: "#FBF2D5" },
    ],

    statusRepVisit: {
        "TASK_CREATED": "tasks.created",
        "TASK_POSTPONED": "tasks.postponed",
        "TASK_SCHEDULED": "tasks.sheduled",
    },

    statusCancVisit: {
        1: "tasks.created",
        2: "tasks.postponed",
        3: "tasks.sheduled",
    },

    sourceComment: [
        { id: 1, name: "Звонок" },
        { id: 2, name: "Сообщение в WhatsApp" },
        { id: 3, name: "Телеграм" },
        { id: 4, name: "Почта" },
        { id: 5, name: "Клиника" }
    ]


    /*новый список { UNFILLED, INVOICE_FILLED, DIARY_FILLED, INVOICE_DIARY_FILLED, PENDING, OPTIMIZING,
        TASK_POSTPONED TASK_CREATED 
    DOCTOR_APPROVE, DOCTOR_CLINIC_APPROVE, COMPLETED, FAILED } из которых UNFILLED, INVOICE_FILLED, 
    DIARY_FILLED, INVOICE_DIARY_FILLED, COMPLETED может применить только бэк и триггер*/

};

export default config;

